import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	FormattedText,
	Icon,
	Typography
} from "client/Components";
import { reactionIconMap } from "client/Features/Reactions/ReactionsCountButton/ReactionsCountButton";
import { ensureNotNil, setTrackingId } from "client/Misc/utils";
import styles from "./BirthdayWishReactionActivity.module.less";
import { BirthdayWishReactionNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type BirthdayWishReactionActivityProps = {
	data: BirthdayWishReactionNotificationDataViewModel;
};

export const BirthdayWishReactionActivity = (props: BirthdayWishReactionActivityProps): ReactElement => {
	const { data } = props;

	const {
		firstname,
		lastname,
		reaction
	} = data;

	const fullname: string = `${firstname} ${lastname}`;

	return (
		<span {...setTrackingId("title")}>
			<span className={styles.iconContainer}>
				<Icon value={{
					kind: "svg",
					name: ensureNotNil(reactionIconMap[reaction])
				}}/>
			</span>
			<FormattedText
				text={localize("_XReactedOnYourBirthdayWishes")}
				thingsToReplace={[
					{
						what: "{name}",
						filler: (
							<Typography
								trackingId="user-name"
								weight="bold"
							>
								{fullname}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};

BirthdayWishReactionActivity.displayName = "BirthdayWishReactionActivity";